/**
 * SnapshotConfigManager - Configuration and utility functions for snapshot system
 */

export interface SnapshotConfiguration {
  maxSnapshots: number;
  enableCompression: boolean;
  enablePerformanceMonitoring: boolean;
  backgroundProcessing: boolean;
  currentSnapshots: number;
  memoryUsage: string;
}

export interface SnapshotConfigOptions {
  maxSnapshots?: number;
  enableCompression?: boolean;
  enablePerformanceMonitoring?: boolean;
  backgroundProcessing?: boolean;
}

export class SnapshotConfigManager {
  /**
   * Get current configuration with memory usage
   */
  static getConfiguration(
    maxSnapshots: number,
    enableCompression: boolean,
    enablePerformanceMonitoring: boolean,
    backgroundProcessing: boolean,
    currentSnapshots: number,
    averageSnapshotSize: number
  ): SnapshotConfiguration {
    const totalSize = averageSnapshotSize * currentSnapshots;

    return {
      maxSnapshots,
      enableCompression,
      enablePerformanceMonitoring,
      backgroundProcessing,
      currentSnapshots,
      memoryUsage: this.formatBytes(totalSize)
    };
  }

  /**
   * Format bytes for human readable display
   */
  static formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
